import { render, staticRenderFns } from "./UncollectedList.vue?vue&type=template&id=063669b0&scoped=true&"
import script from "./UncollectedList.vue?vue&type=script&lang=js&"
export * from "./UncollectedList.vue?vue&type=script&lang=js&"
import style0 from "./UncollectedList.vue?vue&type=style&index=0&id=063669b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063669b0",
  null
  
)

export default component.exports